// extracted by mini-css-extract-plugin
var _1 = "Muzsq";
var _2 = "b3zet";
var _3 = "VAw8M elide";
var _4 = "PoV24 elide";
export { _1 as "base", _2 as "box", _3 as "leftColumn", _4 as "rightColumn" }
